import { createApiHook } from '../hooks';
import { pushReportApiFactory } from './pushReportApiFactory';

export const usePushReportApi = createApiHook(pushReportApiFactory);
